import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute";
import { routes } from "./routesConfig";
import Loader from "../components/Loader/Loader";
import styled from "styled-components";

const LazyNotFoundPage = React.lazy(
  () => import("../pages/NotFoundPage/NotFoundPage"),
);

const PageFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 20rem;
`;

const AppRoutes = () => (
  <Suspense
    fallback={
      <PageFallback>
        <Loader />
      </PageFallback>
    }
  >
    <Routes>
      {routes.map((route) => {
        const PageComponent = route.page;

        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              route.isPrivate ? (
                <ProtectedRoute>
                  <PageComponent />
                </ProtectedRoute>
              ) : (
                <PageComponent />
              )
            }
          />
        );
      })}
      <Route path="*" element={<LazyNotFoundPage />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
